/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React, { useMemo } from 'react';
import { getStandardButtons, StandardsButtons, getStandardButton } from './getStandardButtons';
import { getFrameworkButtons } from './getFrameworkButtons';
import ToolbarCollapsedMenu from './ToolbarCollapsedMenu';
import ToolbarDivider from './ToolbarDivider';
import ToolbarColumn from './ToolbarColumn';
import './StandardsFrameworks.scss';
import ToolbarButton from './ToolbarButton';

const StandardsFrameworks = (props: StandardsButtons) => {
  const { utr, standardShow, selectedStandard, showSelectedStandard, handleStandardsClick } = props;

  const selectedButton = useMemo(() => {
    if (showSelectedStandard) {
      return getStandardButton({ utr, selectedStandard, standardCode: selectedStandard, handleStandardsClick });
    }
  }, [utr, selectedStandard, showSelectedStandard, handleStandardsClick]);

  return (
    <div className='standards-frameworks-toolbar d-flex flex-fill'>
      {showSelectedStandard && selectedButton && (
        <div className='standards-frameworks-toolbar__selected'>
          <ToolbarButton {...selectedButton} />
        </div>
      )}
      <ToolbarCollapsedMenu
        title={'Standards'}
        buttons={getStandardButtons(props)}
        key={utr.getId()}
        standardShow={standardShow}
      />
      <ToolbarDivider hidden={getFrameworkButtons(props).length === 0} />
      <ToolbarColumn title={'Frameworks'} className='flex-fill' icons={getFrameworkButtons(props)} />
    </div>
  );
}

export default StandardsFrameworks;
